export default function ShowPassword() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99965 11.1653C9.47186 11.1653 10.6653 9.97186 10.6653 8.49965C10.6653 7.02744 9.47186 5.83398 7.99965 5.83398C6.52744 5.83398 5.33398 7.02744 5.33398 8.49965C5.33398 9.97186 6.52744 11.1653 7.99965 11.1653Z"
        fill="#CEB2E9"
      />
      <path
        d="M15.5112 6.77916C14.4776 5.09578 12.1265 2.27148 7.99998 2.27148C3.87352 2.27148 1.52239 5.09578 0.488772 6.77916C-0.162924 7.83323 -0.162924 9.16511 0.488772 10.2192C1.52239 11.9026 3.87352 14.7269 7.99998 14.7269C12.1265 14.7269 14.4776 11.9026 15.5112 10.2192C16.1629 9.16511 16.1629 7.83323 15.5112 6.77916ZM7.99998 12.4977C5.79168 12.4977 4.00147 10.7075 4.00147 8.49917C4.00147 6.29087 5.79168 4.50066 7.99998 4.50066C10.2083 4.50066 11.9985 6.29087 11.9985 8.49917C11.9963 10.7066 10.2074 12.4955 7.99998 12.4977Z"
        fill="#CEB2E9"
      />
    </svg>
  );
}
